import { Card } from "flowbite-react";
import ProfileSettings from "./ProfileSettings";
import Password from "./Password";
import UserInvitation from "./UserInvitation";
import { useAuth } from "../../contexts/AuthContext";

const Profile = () => {
  const { user } = useAuth();

  return (
    <div className="p-4 space-y-4">
      <Card>
        <h1 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">Profile Settings</h1>
        <ProfileSettings />
      </Card>
      <Card>
        <h2 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">Password</h2>
        <Password />
      </Card>
      {user.role === 'su' && (
        <Card>
          <h2 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">Invite User</h2>
          <UserInvitation />
        </Card>
      )}
    </div>
  );
}

export default Profile;
